module.exports = __webpack_public_path__ + "static/media/ic205renew.4639a141.png";